export const sitesChannelHc = {
  paginasWeb: {
    pageTitle: "Website",
    introCreated:
      "Your website is already created. Come in and edit it whenever you like.",
    introEmpty:
      "Create your property's website, with your calendar built in. You edit it by dragging, no coding required.",
    emptyTitle: "You don't have a website yet",
    emptyBody:
      "You pick a template for your sector, swap the photos and text, and you have a publishable website. The date search stays connected to your calendar.",
    creating: "Creating…",
    createCta: "Create my website",
    createAnother: "Create another site",
    collapse: "Collapse",
    expand: "See details",
    limitReached: "Your plan allows {n} site(s).",
    lockedTitle: "Your website comes with the Suite plan",
    lockedBody:
      "To create and manage your property's website with WACheckin, you need an active Suite plan.",
    lockedCta: "See the Suite plan",
    nameLabel: "Your website's name",
    viewWeb: "View website",
    opening: "Opening…",
    editCta: "Edit my page",
    noPublicAddress: "It doesn't have a public address yet",
    published: "Published",
    unpublished: "Unpublished",
    visibleToPublic: "Visible to the public",
    addressTitle: "Your website's address",
    addressSubtitle: "Choose which address you want your guests to see it at.",
    modeWacheckin: "Use a WACheckin address",
    modeWacheckinHint: "Free and ready right away",
    modeOwn: "Use your own domain",
    modeOwnHint: "If you already have one",
    subdomainLabel: "The word that goes in front",
    subdomainPlaceholder: "your-accommodation-name",
    saving: "Saving…",
    save: "Save",
    subdomainPreview: "Your website will be at",
    subdomainFree:
      "Write it however you like: we turn it into a valid address.",
    otherDomainNote:
      "You also have {dominio} connected. This address will keep working and will lead to the same website.",
    noDomainYet: "You haven't said which domain you want yet",
    continueConnection: "Continue the connection",
    connectDomain: "Connect my domain",
    searchTitle: "Which accommodations the search can show",
    searchSubtitle:
      "The ones you check here are the ones your guests will see when searching for dates.",
    missingPhotosLabel: "No photos yet:",
    missingPhotosHelp:
      "Upload them in Direct bookings → Images and they'll appear here. They don't need to be on sale.",
    previewError: "The preview could not be loaded.",
    previewRetry: "Try again",
    deleteExplain: "Deletes the site and everything in it. This cannot be undone.",
    deleteTitle: "Delete “{nombre}”?",
    deleteBody: "This cannot be undone. If you only want to hide it, switch off “Visible to the public” and the site stays saved.",
    deleteItemPages: "Its {n} pages, with their text and design",
    deleteItemAddress: "The address it is served at",
    deleteItemMessages: "The messages you received through its forms",
    deleteCancel: "Cancel",
    deleteConfirm: "Yes, delete",
    deleting: "Deleting…",
    previewTitle: "Your site right now",
    previewDesktop: "Desktop",
    previewMobile: "Mobile",
    previewLoading: "Loading your site…",
    previewNote: "This is how it looks with your latest saved changes. Guests see whatever you published last.",
    footerNote:
      "For now each account has one website. Write to us if you need more.",
    deleteWeb: "Delete this website",
    mensajes: {
      title: "Messages from your website",
      subtitle: "What people write in your website's forms. Each one also reaches you by email.",
      inbox: "Inbox",
      archived: "Archived",
      unread: "{n} unread",
      empty: "Nobody has written yet. When someone fills in a form on your website you'll see it here, and you'll get it by email.",
      emptyArchived: "You have no archived messages.",
      loadError: "Messages could not be loaded.",
      retry: "Try again",
      reply: "Reply by email",
      whatsapp: "WhatsApp",
      call: "Call",
      markRead: "Mark as read",
      markUnread: "Mark as unread",
      archive: "Archive",
      unarchive: "Move to inbox",
      delete: "Delete",
      confirmDelete: "Delete this message? This cannot be undone.",
      confirmYes: "Yes, delete",
      confirmNo: "No",
      form: "Form",
      from: "From",
      more: "Load more",
      anonymous: "No name",
      replySubject: "Your message on {sitio}",
      notSent: "The email alert has not gone out yet.",
      errorAction: "The change could not be saved. Please try again.",
    },
    loadingAccommodations: "Loading your accommodations…",
    noPhotosYet:
      "None of your accommodations have photos yet. Upload them in Direct bookings → Images and you'll be able to show them here.",
    noAccommodations: "You don't have any accommodations created yet.",
    loadError: "Your pages couldn't be loaded.",
    defaultSiteName: "My accommodation",
    createError: "The page couldn't be created.",
    saveError: "It couldn't be saved.",
    subdomainTooLong: "It's ended up too long.",
    subdomainReserved: "That word is reserved. Try another one.",
    addressSaved: "Address saved.",
    subdomainChecking: "Checking if it's free…",
    subdomainAvailable: "It's free. Your website will be at",
    subdomainChangeWarning: "Once you save it, your current address will stop working.",
    subdomainTaken: "Another website already uses that address.",
    subdomainTryThis: "This one is free:",
    subdomainUse: "Use this one",
    subdomainGeneric: "It says nothing about your accommodation. We suggest:",
    subdomainProposal: "We suggest one with your accommodation's name:",
    domainHelpEmpty:
      "We guide you step by step: you type in the domain, copy two lines into the panel where you bought it, and we check it for you.",
    domainHelpPending:
      "The records are missing in your domain's panel, or they haven't propagated everywhere yet. Go in and we'll check it.",
    popupBlocked: "Allow pop-ups to open the editor.",
    editorError: "The editor couldn't be opened.",
    confirmDelete: `Delete "{nombre}"? The website will stop showing.`,
    deleteError: "It couldn't be deleted.",
  },

  selectOta: {
    lockBadge: "Subscription feature",
    lockTitle: "Connect your OTAs with an active plan",
    lockText:
      "To sync <b>Booking, Airbnb, Vrbo, Expedia</b> and more channels with WA&nbsp;Checkin you need to be subscribed to a plan. With your subscription, Janet syncs prices, availability and bookings automatically — no overbooking and no manual tasks.",
    morePreviewTitle: "and more than 100 OTAs",
    otasAvailable: "OTAs available",
    lockCta: "See plans and subscribe",
    lockFoot:
      "Automatic sync · Anti-overbooking · Connection support included",
    connectOtaTitle: "Connect OTA",
    googleFaltan: "Your listing is missing 1 thing for Google | Your listing is missing {count} things for Google",
    googlePreparar: "Prepare it",
    beta: "Beta",
    pctChipTitle: "Derived rate percentage for this OTA",
    comingSoon: "Coming soon",
    manage: "Manage",
    connectNow: "Connect now",
    pctModalTitle: "Rate percentage",
    pctModalHint:
      "What percentage more (or less) will you charge your guests if they book through <b>{ota}</b>? Use <b>+</b> to charge more or <b>−</b> to charge less (e.g.: <b>15.5</b> or <b>−10</b>).",
    thisOta: "this OTA",
    cancel: "Cancel",
    saving: "Saving…",
    save: "Save",
    exploreMore: "Explore more than 100 available OTAs",
    activeConnections: "Active Connections",
    searchPlaceholder: "Search...",
    loadingConnections: "Loading connections...",
    thChannel: "CHANNEL",
    thConnectionId: "CONNECTION ID",
    thLastSync: "LAST SYNC",
    thActions: "ACTIONS",
    copied: "Copied!",
    copyId: "Copy ID",
    contactTitle: "Connect with {name}",
    contactDescription:
      "Easily connect your {name} account to our platform to speed up your experience. Follow the steps below to complete the process.",
    step1Title: "Create a {name} account",
    step1Description:
      "If you don't have a {name} account yet, you'll first need to create one.",
    createAccountLink: "Create account →",
    step1Hint: "Already have an account? Go to step 2.",
    step2Title: "Contact the support team",
    step2Description:
      "Once your {name} account is ready, our team will help you connect it.",
    contactSupportLink: "Contact the support team →",
    connectDirectNoSupport: "Connect directly (without support) →",
    step2Hint: "Recommended only if you know what you're going to configure in Channex.",
    connectDirectly: "Connect directly",
    iframeTitle: "Connect with {channel}",
    iframeSubtitle: "Secure connection managed by the channel manager",
    close: "Close",
    iframeLoading: "Opening the secure connection…",
    actionRequired: "Action required",
    viewPlans: "See plans",
    descBooking: "Reach business and leisure travelers all over the world",
    descAirbnb: "Connect your property with millions of travelers on Airbnb",
    descVrbo: "Specialized in vacation rentals for families",
    descExpedia: "Global travel network with millions of active users",
    descBnb: "Italian portal for B&Bs and charming accommodations",
    descGvr: "Appear for free in Google Maps results and searches",
    descAgoda: "Reach travellers from Asia and the rest of the world",
    descHotelbeds: "Beds for travel agents and tour operators worldwide",
    savePercentError: "The percentage couldn't be saved. Please try again.",
    channelGeneric: "Channel",
    statusInactive: "Inactive",
    statusConnected: "Connected",
    statusSyncing: "Syncing",
    webReservationsName: "Direct bookings via web",
  },

  connectionChannel: {
    errorTitle: "Error",
    successTitle: "Success",
    connectionDisabled: "The connection is disabled",
    syncError: "Error while syncing",
    loadPropertiesError: "Error loading properties",
    connectionUpdated: "Connection updated {channelName}",
    updateConnError: "Error updating the connection: {detail}",
    unknownError: "Unknown error",
    connectionWith: "Connection with {channelName} {status}",
    stateUpdatedTitle: "Status updated",
    confirmDeleteMessage:
      "Are you sure you want to delete this connection? This will also delete the associated properties and bookings.",
    confirmDeleteHeader: "Confirm deletion",
    deleteConnection: "Delete connection",
    no: "No",
    connectionDeleted: "Connection deleted successfully",
    deleteConnError: "Error deleting the connection: {detail}",
    webhookCopied: "Webhook copied to the clipboard",
    webhookCopyError: "Error copying the webhook",
    title: "Connection channel (PMS)",
    description:
      "In this section you can connect with property management systems (PMS) to query, manage and update information efficiently and without errors.",
    connectedAccount: "Connected account",
    switchTooltip:
      "Stop or start the service that automatically receives bookings into the system.",
    syncing: "Syncing...",
    sync: "Sync",
    deleting: "Deleting...",
    webhookLabel: "WEBHOOK:",
    webhookInfoTooltip:
      "Add this Webhook to your Smoobu account to automatically receive the bookings created in your PMS",
    copyToClipboard: "Copy to clipboard",
    syncedProperties: "Synced properties",
    noAddress: "No address",
    noSyncedProperties: "There are no synced properties",
  },

  wabaIntegration: {
    activationInProgress: "Activation in progress",
    pendingBody:
      "We're activating your business WhatsApp. While Meta approves your templates (it usually takes up to 24&nbsp;h) and verifies your number, your messages are sent with <strong>WACheckin's WhatsApp</strong> so you don't stop communicating with your guests. It will switch to your own number <strong>automatically</strong> as soon as it's ready — you don't have to do anything.",
    phoneStatusHeading: "WhatsApp number status",
    numberLabel: "Number:",
    virtualNumberNote:
      "This is a <strong>virtual number provided by Meta</strong>. It doesn't receive normal calls or SMS, only WhatsApp messages through the API.",
    statusLabel: "Status:",
    templatesStatusHeading: "Templates status",
    canSend:
      "Your number is <strong>connected and verified</strong> and you have at least one approved template. You can now send messages.",
    cannotSendYet:
      "You <strong>can't send messages yet</strong>. Wait for Meta to approve the phone number and the templates.",
    virtualPendingNote:
      "Keep in mind that, if your business on Meta isn't verified, virtual numbers may stay in <strong>pending</strong> status and not allow sending.",
    statusConnectedVerified: "Connected and verified",
    statusConnectedPending: "Connected, pending verification",
    statusPendingApproval: "Pending approval",
    statusDisconnected: "Disconnected",
    statusUnknown: "Unknown",
  },
};
